export default __webpack_public_path__ + "static/bentoSectionBg1-6c689e6a33b01b519dbe8236d5e0fff7.webp";